// extracted by mini-css-extract-plugin
export default {"input-with-icon":"TagReadInput_input-with-icon__f7CMa","main-input-wrapper":"TagReadInput_main-input-wrapper__Azhve","input-barcode-icon":"TagReadInput_input-barcode-icon__vreJH"};